/* eslint-disable implicit-arrow-linebreak */

export const apiContenedoresImportacionGet = (materialesExportacionParaDescargar, filtroImportacion) =>
    fetchApi("api/descarga_dirigida", {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            contenedores: materialesExportacionParaDescargar,
            fecha_filtro_importacion: filtroImportacion,
        }),
        error: {
            callback: () => {
                throw new Error("Lo sentimos, ocurrió un error en la solicitud");
            },
        },
    });

export const apiDescargaDirigidaPost = (descarga) =>
    fetchApi("api/descarga_dirigida", {
        method: "POST",
        body: JSON.stringify({
            descarga,
        }),
        headers: {
            "Content-Type": "application/json",
        },
        default: [],
    });

export const apiFinalizaDescargaDirigida = (pedimentoId) =>
    fetchApi(`api/descarga_dirigida/${pedimentoId}`, {
        method: "PATCH",
    });
